import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * The second factor of BP-01 §6's staff login: the one-time code field
 * (R7 — `pyotp`, 30 s, 6 digits).
 *
 * It is a fieldset inside `LoginForm`, not a screen of its own: the api verifies
 * password and code in the *same* `POST /auth/login` call
 * (`LoginIn{email,password,totp?}`, §5), so there is nothing to submit on its
 * own and nothing to remember between two requests.
 */
export function TotpStep(): JSX.Element {
  const { t } = useTranslation('auth');

  return (
    <fieldset className="space-y-2 rounded border border-border p-3" data-testid="totp-step">
      <legend className="px-1 text-sm font-medium">{t('totp.title')}</legend>
      <p className="text-sm text-muted-foreground">{t('totp.hint')}</p>
      <label className="block">
        <span className="block text-sm text-muted-foreground">{t('totp.code')}</span>
        <input
          name="totp"
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={10}
          className="mt-1 w-full rounded border border-border p-2"
        />
      </label>
    </fieldset>
  );
}
